module.exports = __webpack_public_path__ + "static/media/settings.13128bd7.svg";